import { render, staticRenderFns } from "./RefundPolicyDetailsPage.vue?vue&type=template&id=62f04976"
import script from "./RefundPolicyDetailsPage.vue?vue&type=script&lang=js"
export * from "./RefundPolicyDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports